export default function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-number.js
// module id = 179
// module chunks = 113